import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Pediatrics.css';

const Pediatrics = () => {
    const pricing = [
        { type: "Sealants", price: "₱1,000" },
        { type: "Extraction", price: "₱1,000" },
        { type: "SS Crown", price: "₱4,000" },
        { type: "Space Maintainer (UNI)", price: "₱3,500" },
        { type: "Space Maintainer (BILA)", price: "₱8,000 - ₱10,000" },
    ];
 
    return (
        <>
        <Header/>
        <div className="pediatrics-container">
          
            <div className="pediatrics-content">
                <h1>PEDIATRICS</h1>
                <p>
                Pediatric dental surgery focuses on procedures for children, often involving tooth extractions 
                due to decay, trauma, or to make room for permanent teeth. Other procedures include pulpotomy 
                (treating the inner part of a tooth) and pulpectomy (removing the entire pulp).
                </p>
                <h2>Pricing</h2>
                <table className="pediatrics-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default Pediatrics;